import { useState } from 'react';
import { PatrolRoundsPage, PatrolCheckpointsPage } from '@/modules/logbook';
import { useI18n } from '@/shared/i18n';
import { Route, MapPin } from 'lucide-react';

type PatrolTab = 'rounds' | 'checkpoints';

export const Patrol = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState<PatrolTab>('rounds');

  return (
    <div>
      {/* Tabs */}
      <div className="px-4 pt-4">
        <div className="flex gap-2 border-b border-slate-200">
          <button
            onClick={() => setActiveTab('rounds')}
            className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-colors ${
              activeTab === 'rounds'
                ? 'border-primary-600 text-primary-600'
                : 'border-transparent text-slate-500 hover:text-slate-700'
            }`}
          >
            <Route className="w-4 h-4" />
            {t('patrol.rounds')}
          </button>
          <button
            onClick={() => setActiveTab('checkpoints')}
            className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-colors ${
              activeTab === 'checkpoints'
                ? 'border-primary-600 text-primary-600'
                : 'border-transparent text-slate-500 hover:text-slate-700'
            }`}
          >
            <MapPin className="w-4 h-4" />
            {t('patrol.checkpoints')}
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'rounds' && <PatrolRoundsPage />}
      {activeTab === 'checkpoints' && <PatrolCheckpointsPage />}
    </div>
  );
};
